import React, { FC, useEffect, useState } from 'react'
import text from 'styles/utility/text.module.scss'
import { Card, CardInner, RevenueTotalCard } from 'components/Card'
import { OrderType } from 'types/checkout'
import { Spacer } from 'components/Utility'
import { FlexRow } from 'components/Flex'
import { SubCaution } from 'components/Typography'
import { sumOrdersPrice } from 'lib/revenue'

type Props = {
  orderList: OrderType[]
}

const RevenueTotalCardList: FC<Props> = (props) => {
  const { orderList } = props

  const [totalAmount, setTotalAmount] = useState<number>(0)
  const [totalSales, setTotalSales] = useState<number>(0)

  useEffect(() => {
    if (!orderList) return
    setTotalAmount(
      orderList.reduce((prev, order) => {
        return prev + order.items.reduce((prev, item) => prev + item.quantity, 0)
      }, 0)
    )
    setTotalSales(sumOrdersPrice(orderList, true))
  }, [orderList])

  return (
    <Card>
      <CardInner>
        <p className={`${text.font_xxlarge} ${text.font_bold} ${text.align_center}`}>sacri上での売上</p>
        <Spacer size={20} />
        <FlexRow justifyContent={'center'}>
          <RevenueTotalCard label={'総売上 (税込)'} value={totalSales.toLocaleString()} unit={'円'} />
          <Spacer size={8} />
          <RevenueTotalCard label={'販売個数'} value={totalAmount.toLocaleString()} unit={'個'} />
        </FlexRow>
        <Spacer size={8} />
        <SubCaution
          caution={'※表示金額は総売上からsacriの手数料およびそれに掛かる消費税(10%)を引く前の金額となります。'}
        />
      </CardInner>
    </Card>
  )
}

export default RevenueTotalCardList
